(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define(["React"], factory);
	else if(typeof exports === 'object')
		exports["PRSS"] = factory(require("React"));
	else
		root["PRSS"] = factory(root["React"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__883__) => {
return 